



























import Vue from 'vue';
import Component from 'vue-class-component';
import { mdiLightbulbOn } from '@mdi/js';

const Props = Vue.extend({
	props: {
		justifyCenter: {
			type: Boolean,
			default: false
		}
	}
});

@Component
export default class Astuce extends Props {
	iconAstuce = mdiLightbulbOn;
}
